import React, { FC } from "react";

import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemProps,
  ListItemText,
  ListProps,
  Typography,
} from "@mui/material";

import { RelativeDate } from "../../../components/Date";
import UserAvatar from "../../../components/UserAvatar";
import UserDisplayName from "../../../components/UserDisplayName";
import { ActivityLog } from "../../../store/pomeriumApi";
import EntityDescription from "./EntityDescription";

type ActivityLogsListItemProps = {
  activityLog: ActivityLog;
} & ListItemProps;

const ActivityLogsListItem: FC<ActivityLogsListItemProps> = ({
  activityLog,
  ...props
}) => {
  return (
    <ListItem {...props}>
      <ListItemAvatar>
        <UserAvatar variant="rounded" user={activityLog?.user} />
      </ListItemAvatar>
      <ListItemText>
        <Typography variant="subtitle2">
          <Typography
            component="strong"
            variant="subtitle2"
            sx={{ fontWeight: "bold" }}
          >
            <UserDisplayName user={activityLog?.user} />
          </Typography>{" "}
          {activityLog?.activityType === "create"
            ? "created"
            : activityLog?.activityType === "delete"
              ? "deleted"
              : "updated"}{" "}
          <EntityDescription activityLog={activityLog} />
        </Typography>
        <Typography variant="caption" component="div">
          <RelativeDate timestamp={activityLog?.createdAt} />
        </Typography>
      </ListItemText>
    </ListItem>
  );
};

type ActivityLogsListProps = {
  activityLogs: ActivityLog[];
} & ListProps;

const ActivityLogsList: FC<ActivityLogsListProps> = ({
  activityLogs,
  ...props
}) => {
  return (
    <List {...props}>
      {activityLogs.map((activityLog) => (
        <ActivityLogsListItem
          key={`ActivityLogItem-${activityLog?.id}`}
          activityLog={activityLog}
        />
      ))}
    </List>
  );
};
export default ActivityLogsList;
